import React from 'react';
import Modal from './Modal';
import {
  Shield,
  AlertTriangle,
  CheckCircle
} from 'lucide-react';

const ModalAutorizacaoSimples = ({ isOpen, onClose, onConfirm, loading, liberacao }) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const modalContent = (
    <div style={{ padding: '20px' }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '15px',
        marginBottom: '20px',
        paddingBottom: '15px',
        borderBottom: '1px solid #eee'
      }}>
        <div style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          backgroundColor: '#e3f2fd',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Shield size={24} color="#1976d2" />
        </div>
        <div>
          <h3 style={{ margin: 0, color: '#333' }}>Autorizar Liberação</h3>
          <p style={{ margin: '5px 0 0 0', color: '#667', fontSize: '14px' }}>
            Confirme a autorização desta liberação
          </p>
        </div>
      </div>

      {liberacao && (
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '15px',
          borderRadius: '8px',
          marginBottom: '20px'
        }}>
          <div style={{ marginBottom: '10px' }}>
            <strong>Recibo:</strong> {liberacao.numeroRecibo}
          </div>
          <div style={{ marginBottom: '10px' }}>
            <strong>Paciente:</strong> {liberacao.paciente?.nome}
          </div>
          <div style={{ marginBottom: '10px' }}>
            <strong>Total de itens:</strong> {liberacao.totalItens}
          </div>
          <div style={{ marginBottom: '10px' }}>
            <strong>Solicitado por:</strong> {liberacao.usuario?.nome} ({liberacao.usuario?.cargo})
          </div>
          <div>
            <strong>Data:</strong> {new Date(liberacao.dataLiberacao).toLocaleString('pt-BR')}
          </div>
        </div>
      )}

      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '15px',
        backgroundColor: '#fff3cd',
        border: '1px solid #ffeeba',
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <AlertTriangle size={20} color="#856404" />
        <div style={{ fontSize: '14px', color: '#856404' }}>
          <strong>Atenção:</strong> Ao autorizar esta liberação, os medicamentos serão 
          automaticamente descontados do estoque e a liberação ficará disponível para entrega.
        </div>
      </div>

      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <button
          type="button"
          onClick={onClose}
          className="btn btn-secondary"
          disabled={loading}
          style={{ minWidth: '100px' }}
        >
          Cancelar
        </button>
        <button
          type="button"
          onClick={handleConfirm}
          className="btn btn-success"
          disabled={loading}
          style={{ 
            minWidth: '100px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          {loading ? (
            <>
              <div className="spinner" style={{ width: '16px', height: '16px' }}></div>
              Autorizando...
            </>
          ) : (
            <>
              <CheckCircle size={16} />
              Autorizar
            </>
          )}
        </button>
      </div>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title=""
      size="md"
    >
      {modalContent}
    </Modal>
  );
};

export default ModalAutorizacaoSimples;